
import { defineStore } from 'pinia'
import { QiankunStore, MicroApp } from '@/types'

export default () => defineStore('qiankun', {
  state: ():QiankunStore => ({
    microApps: []
  }),
  getters: {
    // collapsed: (state) => state.collapsed,
  },
  actions: {
    setMicroApps(payload: MicroApp[]) {
      this.microApps = payload
    }
  }
})
